var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading",style:(("border-color:" + _vm.color + ";box-shadow: 0px 0px 6px " + _vm.color))}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }